<template>
  <div class="page">
    <PageHeader>
      Экспорт транзакций
    </PageHeader>
    <div v-loading="loading" class="sub_header">
      <div style="display: block;padding:0.5rem">
        {{ description }}
      </div>
      <div>
        <el-pagination
          @current-change="goToPage"
          @size-change="l => changeLimit({ limit: l })"
          :current-page.sync="pageLocal"
          :page-size="limit"
          layout="sizes, prev, pager, next, jumper"
          :total="totalDocs"
        >
        </el-pagination>
      </div>
    </div>
    <div v-loading="loading" class="content">
      <div v-for="(transaction, index) in transactions" :key="transaction._id">
        <component
          :is="transactionComponent"
          :key="transaction._id"
          :transaction="transaction"
        ></component>
        <div class="verification-image" v-if="transaction.verificationImage">
          <img
            :src="
              `/uploads/verificationImages/${transaction.verificationImage}`
            "
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { queryTransactions, getTransactionsWithEmailCsv } from "@/api";
import { mapState, mapActions } from "vuex";
import OrderTransaction from "../../ui/OrderTransaction.vue";
import OrderTransactionNew from "../../ui/OrderTransactionNew.vue";
import PageHeader from "../../ui/PageHeader.vue";

//
export default {
  components: { PageHeader },
  name: "TrExport",

  data: () => ({
    query: "",
    filterdata: null,
    description: "",
    trWithEmail: [],
    selectedComponent: "classic",
    transactionComponents: [
      { component: OrderTransaction, title: "Классик", id: "classic" },
      { component: OrderTransactionNew, title: "Модерн", id: "modern" }
    ]
  }),

  methods: {
    ...mapActions("transactionsNew", [
      "getTransactions",
      "changeQuery",
      "onlySetPage",
      "onlySetSort",
      "onlySetLimit",
      "goToPage",
      "changeLimit"
    ]),
    getatob(data) {
      return atob(data);
    }
  },

  computed: {
    ...mapState("transactionsNew", [
      "transactions",
      "loading",
      "totalPages",
      "totalDocs",
      "page",
      "limit",
      "sort"
    ]),
    transactionComponent() {
      return this.transactionComponents.find(
        c => c.id === this.selectedComponent
      )["component"];
    },
    pageLocal: {
      get() {
        return this.page;
      },
      set(val) {
        this.goToPage({ page: val });
      }
    }
  },

  async mounted() {
    this.filterdata = this.$route.params["filterdata"];
    try {
      const filterdataObj = JSON.parse(atob(this.filterdata));
      this.changeQuery({ query: filterdataObj.query });
      this.onlySetPage({ page: filterdataObj.page });
      this.onlySetSort({ sort: filterdataObj.sort });
      this.onlySetLimit({ limit: filterdataObj.limit });
      this.description = filterdataObj.description;
      await this.getTransactions();
    } catch (error) {
      console.log(error);
    }
  }
};
</script>

<style scoped>
.green {
  border-left: 5px solid green;
}
.orange {
  border-left: 5px solid orange;
}
.red {
  border-left: 5px solid red;
}

.content {
  overflow: hidden;
}

.block-left,
.block-right {
  float: left;
  padding: 0 5px 10px 5px;
  width: calc(50% - 11px);
}

.block-left {
  border-right: 1px solid #d9d9d9;
}

.buttons {
  margin-top: 10px;
  display: inline-block;
  width: 100%;
}

.buttons > button {
  width: 49%;
  display: inline-block;
  cursor: pointer;
}

.buttons > button.ok {
  background-color: green;
  color: #ffffff;
}

.buttons > button.cancel {
  background-color: red;
  color: #ffffff;
}

.verification-image {
  max-width: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  margin-top: 20px;
  border: 1px solid #aaa;
}
.verification-image img {
  display: block;
  width: 100%;
  height: auto;
}

.wallet-form-additional-info {
  font-size: 15px;
  color: blue;
  font-weight: 600;
}

.sub_header {
  margin-top: 60px;
}

#app > .page > .content {
  margin-top: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/TransactionsExport/index.vue